import { Media, Species, SpeciesDetail } from '@omniafishing/core';
import _ from 'lodash';
import React from 'react';
import bgPattern from '../../assets/topo-blue-pattern.png';
import { LoadingState } from '../../constants/loading_state';
import { PrismicDocument, PrismicQa } from '../../prismic';
import { RoutePaths } from '../../routes';
import { ContentWrapper } from '../content_wrapper/content_wrapper';
import { MediaCardLegacy } from '../media_card_legacy/media_card_legacy';
import { OmniaBreadcrumb } from '../omnia_breadcrumb/omnia_breadcrumb';
import { QuestionsCollapse } from '../questions_collapse/questions_collapse';
import styles from './species_detail.less';
import { SpeciesProductsGridContainer } from './species_products_grid_container';

interface SpeciesDetailProps {
  media: Media[];
  isMobile: boolean;
  loadingState: LoadingState;
  qas: PrismicDocument<PrismicQa>[];
  speciesDetail: SpeciesDetail;
  selectedSpecies: Species;
}

export const SpeciesDetailComponent = (props: SpeciesDetailProps) => {
  const { qas, media, selectedSpecies } = props;

  const hasVideosArticles = !!media.length;

  const { page_heading, page_subheading, banner_image, display_name, description } =
    selectedSpecies;

  const heading = page_heading || `${_.startCase(display_name)} Fishing`;

  return (
    <section>
      <header
        className={styles.header}
        style={{ backgroundImage: `url(${banner_image || bgPattern})` }}
      >
        <ContentWrapper>
          <div className={styles.blurb}>
            <h1 className={styles.h1}>{heading}</h1>
            {page_subheading && <p className={styles.subhead}>{page_subheading}</p>}
            {description && <div dangerouslySetInnerHTML={{ __html: description }} />}
          </div>

          <OmniaBreadcrumb
            items={[
              {
                name: 'Species',
                url: RoutePaths.SPECIES,
              },
              {
                name: display_name,
                url: null,
              },
            ]}
            className={styles.breadcrumb}
          />
        </ContentWrapper>
      </header>

      <section className={styles.products}>
        <SpeciesProductsGridContainer
          selectedSpecies={selectedSpecies}
          key={selectedSpecies.name}
        />
      </section>

      {hasVideosArticles && (
        <ContentWrapper>
          <h2 className={styles.h2}>Videos &amp; Articles ({media.length})</h2>
          <ul className={styles.contentList}>
            {media.map((content) => {
              return (
                <li className={styles.content} key={content.uid}>
                  <MediaCardLegacy media={content} imgWidth={427} />
                </li>
              );
            })}
          </ul>
        </ContentWrapper>
      )}
      {qas.length > 0 && (
        <ContentWrapper>
          <h2 className={styles.h2}>Common Questions About {display_name}</h2>
          <QuestionsCollapse qas={qas} />
        </ContentWrapper>
      )}
    </section>
  );
};
